import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const usePresetDialogStyles = makeStyles(({ spacing }) =>
  createStyles({
    presetFieldDialog: {
      marginTop: spacing(2),
    },
    systemPresetWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
    },
  })
);

export default usePresetDialogStyles;
